import { Component, OnInit } from '@angular/core';
import { DataConnectService } from 'src/app/services/data-connect.service';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router } from '@angular/router';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import * as XLSX from 'xlsx';
import { FileSaverDirective, FileSaverService } from 'ngx-filesaver';
import { IValoresFiltro } from 'src/interfaces/interfaces';
@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})

export class InicioComponent implements OnInit {
  env = environment;
  // arreglo  solicitudes
  entrada: any = [];
  //entrada2: any = [];
  // variables paginacion
  totalItems: number;
  page: number = 1;
  pageSize: number = parseInt(localStorage.getItem('pageSize')) || 100;
  paginas: number;
  aux: number = 0;
  arreglo = [];
  Estado = '99';
  reparticiones: any;
  repar = '0';
  fechaInicio = new Date();
  fechaTermino = new Date();
  fechaI: string;
  fechaT: string;
  currDiv: number = -1;
  formato: any;
  image: any;
  test: any;
  imgidsolicitud: any;
  base64: any;
  imageName: string;
  imageBlob: any;

  genero = '-1';
  tipo = '-1';
  nrosolicitud: any;
  documentopersona: any;
  nombre: any;
  apellido: any;
  palabra: any;

  generoservices: any[] = [];
  tiposervices: any[] = [];

  conectado: any = {
    correcto: 'true',
    message: ""
  }

  inicioFiltro: IValoresFiltro;

  constructor(private _service: DataConnectService, private datePipe: DatePipe, public auth: AuthService,
    public sanitizer: DomSanitizer, public router: Router, private fileSaver: FileSaverService) {




    //console.log( this.auth.datosusuario.data.CDTPPermiso, this.auth.datosusuario.data.rut,this.fechaI, this.fechaT, this.Estado, this.repar)
    // this.bandejaentrada( this.auth.datosusuario.data.CDTPPermiso, this.auth.datosusuario.data.rut,this.fechaI, this.fechaT, this.Estado, this.repar);
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });

  }

  setpageSize(value) {
    localStorage.setItem('pageSize', `${value}`)

  }
  ngOnInit() {

    this.inicializa();

    if (this._service.volver != true) {
      this._service.setValoresFiltro(this.fechaI, this.fechaT, this.Estado, this.repar, this.genero,
        this.tipo,
        this.nrosolicitud,
        this.documentopersona,
        this.nombre,
        this.apellido,
        this.palabra)

    }

    this.filtrar()

    this.BReparticionAsignar()

    this.getGenero();
    this.getTipoSolicitud();
  }

  BReparticionAsignar() {
    return this._service.BReparticionAsignar().subscribe(
      res => {
console.log(res)
        this.reparticiones = res;
      }
    )
  }


  filtrar() { //boton filtrar

    this.inicioFiltro = this._service.getValoresFiltro()
    // this.bandejaentrada(this.auth.datosusuario.data.CDTPPermiso, this.auth.datosusuario.data.rut, this.fechaI, this.fechaT, this.Estado, this.repar, this.genero,
    //   this.tipo,
    //   this.documentopersona,
    //   this.nombre,
    //   this.apellido,
    //   this.palabra)

    this.bandejaentrada(this.auth.datosusuario.data.CDTPPermiso, this.auth.datosusuario.data.rut,
      this.inicioFiltro.fechaI, this.inicioFiltro.fechaT, this.inicioFiltro.Estado, this.inicioFiltro.repar, this.inicioFiltro.genero,
      this.inicioFiltro.tipo,
      this.inicioFiltro.nrosolicitud,
      this.inicioFiltro.documentopersona,
      this.inicioFiltro.nombre,
      this.inicioFiltro.apellido,
      this.inicioFiltro.palabra)

  }


  bandejaentrada(tpusuario, nrrut, fechaI, fechaT, Estado,
    repar, genero, tipo, nrosolicitud, documentopersona, nombre, apellido, palabra) {
    this.entrada = [];

    this._service.verificaTokenOficial().subscribe((res: any) => {
      this.conectado = res
      // if (this.conectado.correcto) {
      return this._service.bandejaentradaDos(tpusuario, nrrut, fechaI,
        fechaT, Estado, repar, genero, tipo, nrosolicitud,
        documentopersona,
        nombre,
        apellido,
        palabra).subscribe(
          res => {
            console.log(res, "respuesta desde la base de datos")
            this.entrada = res;
            this.totalItems = this.entrada.length
          }, error => console.log(error, 'pablo')

        )
      // }
      // else {
      //   console.log("desconectar")
      //   this.auth.logout();

      // }
    })

  }

  limpiar() {
    this.inicializa();
    this.inicioFiltro.tipo = "-1";
    this.inicioFiltro.Estado = "99";
    this.inicioFiltro.nrosolicitud = "-1";
    this.inicioFiltro.apellido = null;
    this.inicioFiltro.nombre = null;
    this.inicioFiltro.palabra = null;
    this.inicioFiltro.repar = 0;
    this.tipo = "-1";
    this.Estado = "99";
    this.nrosolicitud = "";
    this.apellido = null;
    this.nombre = null;
    this.palabra = null;
    this.repar ="0";
    this.filtrar();

  }

  inicializa() {
    this.fechaInicio = new Date('2021-07-02');
    this.fechaI = this.datePipe.transform(this.fechaInicio, 'yyyy-MM-dd');
    this.fechaT = this.datePipe.transform(this.fechaTermino, 'yyyy-MM-dd');
  }


  verimg(IDSolicitud, NMTPFormato, index) {

    this.test = ''
    this.imgidsolicitud = IDSolicitud
    //console.log(NMTPFormato)
    //this.image.forEach(element => {
    if (this.image[index].IDSolicitud == IDSolicitud && NMTPFormato == this.image[index].NMTPFormato) {
      if (NMTPFormato == 'PDF') {
        //          this.test = {obj: this.sanitizer.bypassSecurityTrustHtml(`<object class="img-thumbnail"
        // data="${this.image[index].imgbase64}" type = "application/pdf" > </object>`), indice :index}
        this.base64 = this.image[index].imgbase64.split(',')
        //console.log(this.base64[1])
        this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${this.image[index].imgbase64}`), indice: index }
        this.imageName = `Adjunto.${NMTPFormato}`;
        this.imageBlob = this.dataURItoBlob(this.base64[1], NMTPFormato);
        this.test = new File([this.imageBlob], this.imageName, { type: `application/${NMTPFormato}` });
        const url = window.URL.createObjectURL(this.test);
        window.open(url);

        //console.log(this.test)
      } else if (NMTPFormato == 'JPG' || NMTPFormato == 'PNG') {
        // this.test = {obj: this.sanitizer.bypassSecurityTrustHtml(`<img class="img-thumbnail"
        // src="${this.image[index].imgbase64}" > </img>`), indice : index}
        this.base64 = this.image[index].imgbase64.split(',')
        // console.log(this.base64[1])
        this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${this.image[index].imgbase64}`), indice: index }
        this.imageName = `Adjunto.${NMTPFormato}`;
        this.imageBlob = this.dataURItoBlob(this.base64[1], NMTPFormato);
        this.test = new File([this.imageBlob], `Adjunto.${NMTPFormato}`, { type: `image/${NMTPFormato}` });
        const url = window.URL.createObjectURL(this.test);
        window.open(url);
      } else if (NMTPFormato == 'DOC') {
        this.base64 = this.image[index].imgbase64.split(',')
        //console.log(this.base64[1])
        this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${this.image[index].imgbase64}`), indice: index }
        this.imageName = `Adjunto.${NMTPFormato}`;
        this.imageBlob = this.dataURItoBlob(this.base64[1], NMTPFormato);
        this.test = new File([this.imageBlob], `Adjunto.${NMTPFormato}`, { type: `application/msword` });
        const url = window.URL.createObjectURL(this.test);
        window.open(url);
      } else if (NMTPFormato == 'XLS') {
        this.base64 = this.image[index].imgbase64.split(',')
        //console.log(this.base64[1])
        this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${this.image[index].imgbase64}`), indice: index }
        this.imageName = `Adjunto.${NMTPFormato}`;
        this.imageBlob = this.dataURItoBlob(this.base64[1], NMTPFormato);
        this.test = new File([this.imageBlob], `Adjunto.${NMTPFormato}`, { type: `application/vnd.ms-excel` });
        const url = window.URL.createObjectURL(this.test);
        window.open(url);
      }

      //return this.test
    }
    // })
  }


  dataURItoBlob(dataURI, formato) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    var formatoaux;
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    if (formato == 'PDF') {
      formatoaux = 'application/PDF'
    } else if (formato == 'JPG' || formato == 'PNG') {
      formatoaux = `image/${formato}`
    } else if (formato == 'DOC') {
      formatoaux = 'application/msword'
    } else if (formato == 'XLS') {
      formatoaux = 'application/vnd.ms-excel'
    }
    const blob = new Blob([int8Array], { type: formatoaux });
    return blob;
  }


  ShowDiv(divVal: number) {
    if (this.currDiv == divVal) {
      this.currDiv = -1
    } else {
      this.currDiv = divVal;
    }
  }

  imagenes(idSolicitud) {
    this.test = ''
    return this._service.Imagenes(idSolicitud).subscribe(
      res => {
        //console.log(res)
        this.image = res;

      });


    // if (element.NMTPFormato == 'PDF') {
    //   element.image = this.sanitizer.bypassSecurityTrustHtml(`<object class="container-fluid" style="min-height:
    //   400px;max-height:auto;"
    //    data="${element.img}" type = "application/pdf" > </object>`)
    // } else {
    //   element.image = this.sanitizer.bypassSecurityTrustHtml(`<img class="img-thumbnail"
    //    src="${element.img}" > </img>`)



  }

  finalizar(IDSolicitud) {

    return this._service.finalizar(IDSolicitud).subscribe(
      res => {
        //this.bandejaentrada(this.auth.datosusuario.data.CDTPPermiso, this.auth.datosusuario.data.rut, this.fechaI, this.fechaT, this.Estado, this.repar);
        this.bandejaentrada(this.auth.datosusuario.data.CDTPPermiso, this.auth.datosusuario.data.rut, this.fechaI, this.fechaT, this.Estado, this.repar, this.genero,
          this.tipo,
          this.nrosolicitud,
          this.documentopersona,
          this.nombre,
          this.apellido,
          this.palabra)
      }
    )
  }

  cambioFechaI(fechaI) {
    this.inicioFiltro.fechaI = fechaI
    this.fechaI=fechaI
  }
  cambioFechaT(fechaT) {
    this.inicioFiltro.fechaT = fechaT
    this.fechaT=fechaT
  }
  cambioEstado(Estado) {
    this.inicioFiltro.Estado = Estado
    this.Estado=Estado
  }
  cambioRepar(repar) {
    this.inicioFiltro.repar = repar
    this.repar=repar
  }

  cambioGenero(genero) {
    //  console.log(genero)
    this.inicioFiltro.genero = genero
    this.genero=genero
  }

  cambioTipo(tipo) {

    this.inicioFiltro.tipo = tipo
    this.tipo=tipo
  }

  cambioNrosolicitud(nrosolicitud) {
    this.inicioFiltro.nrosolicitud = nrosolicitud
    this.nrosolicitud=nrosolicitud
  }
  cambioApellido(apellido) {
    //console.log(apellido )
    this.inicioFiltro.apellido = apellido
    this.apellido=apellido
  }

  cambioNombre(nombre) {
    //console.log(apellido )
    this.inicioFiltro.nombre = nombre
    this.nombre=nombre
  }

  cambioPalabra(palabra) {

    this.inicioFiltro.palabra = palabra
    this.palabra=palabra
  }

  getGenero() {
    this._service.getGenero()
      .subscribe((genero: any) => {
        // console.log(genero)
        this.generoservices = genero.result
      })
  }

  getTipoSolicitud() {
    this._service.getTipoSolicitud()
      .subscribe((tipo: any) => {
        // console.log(genero)
        this.tiposervices = tipo.result
      })
  }


  exportar() {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    var tbl = document.getElementById('tbl');
    const hoja2 = XLSX.utils.table_to_sheet(tbl)

    const rows = this.entrada.map(row => ({
      doc: row.GLDocumento,
      nom: row.NMSolicitante,
      pri: row.APPaterno,
      seg: row.APMaterno,
      pai: row.NMNombre,
      reg: row.GLTPRegion,
      com: row.GLTPComuna,
      nsol: row.IDSolicitud,
      detsol: row.GLSolicitud,
      fei: row.FCIngreso,
      asi: row.reparticionAsig,
      tipo: row.GLTPSolicitud,
      estado: row.GLTPEstado,
      estaasi: row.GLTPEstadoAsignacion,
      ult: row.FCRespuesta,

    }));
    const hoja = XLSX.utils.json_to_sheet(rows)
    //  const max_width = hoja['!rows']((w: number, r: { name: string | any[]; }) => Math.max(w, r.name.length), 10);
    //  hoja["!cols"] = [ { wch: max_width } ];
    // hoja["!cols"] = [ { wch: 50 } ];
    var titulos = ["Documento", "Nombres", "Primer Apellido", "Segundo Apellido", "País", "Región", "Comuna", "Número Solicitud", "Detalle Solicitud",
      "Fecha Inicio", "Asignada Repartición", "Tipo Solicitud", "Estado Solicitud", "Estado Asignación", "Fecha ultima Actualización"]
    XLSX.utils.sheet_add_aoa(hoja, [titulos], { origin: "A1" });
    // const libro = {
    //   Sheets: { 'OIRS': hoja, 'OIRSTABLA': hoja2 },
    //   SheetNames: ['OIRS', 'OIRSTABLA']
    // }
    const libro = {
      Sheets: { 'OIRS': hoja },
      SheetNames: ['OIRS']
    }
    const excelBuffer = XLSX.write(libro, { bookType: 'xlsx', type: 'array' });
    const blobdData = new Blob([excelBuffer], { type: EXCEL_TYPE });
    this.fileSaver.save(blobdData, 'OIRS');

  }
}
